import { render } from "./UserForm.vue?vue&type=template&id=099492de&lang=true"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"
script.render = render

export default script